<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-up`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 15.444L7.737 31.707a1 1 0 01-1.415 0l-1.414-1.414a1 1 0 010-1.414L22.586 11.2a2 2 0 012.828 0l17.678 17.678a1 1 0 010 1.414l-1.414 1.414a1 1 0 01-1.414 0L24 15.444z"/></svg>
</template>
<script>

export default {
  name: 'IconUp',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
